/**
 * This represents contact for a team (typically media email). The contact will receive
 * results when the team competes in an event
 */
export class IdentityTeamContact {
    public id: string = null;
    public identityTeamId: string = null;
    public name: string = null;
    public email: string = null;

    public clone(): IdentityTeamContact {
        const clone: IdentityTeamContact = new IdentityTeamContact();
        clone.id = this.id;
        clone.identityTeamId = this.identityTeamId;
        clone.name = this.name;
        clone.email = this.email;

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {
            data: {
                id: this.id,
                type: 'teamContact',
                attributes: {
                    name: this.name,
                    email: this.email,
                },
            },
        };

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any): IdentityTeamContact {
        const data: any = json.data || json;
        const attrs: any = data.attributes;

        this.id = data.id;
        this.name = attrs.name;
        this.email = attrs.email;
        this.identityTeamId = attrs.teamId;

        return this;
    }
}
